export default __webpack_public_path__ + "static/media/Beach side from the market.3570bb56.jpg";